export enum KitStatusEnum {
    WORKING = "WORKING",
    DAMAGED = "DAMAGED",
    UNDER_REPAIRS = "UNDER_REPAIRS",
    EXPIRED = "EXPIRED",
}